module.exports = __webpack_public_path__ + "static/imgs/circle-center-fill2.4b49ae5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/circle/circle-center-fill2.png
// module id = 59tZ
// module chunks = 1